import { useEffect } from "react";
import PropTypes from "prop-types";
import styles from "./Toast.module.scss";
import classNames from "classnames";

const TOAST_TYPES = ["info", "success", "warning", "error"];
const DEFAULT_DURATION = 3000;

const Toast = ({
  icon: Icon,
  type = "info",
  primaryMessage,
  secondaryMessage,
  rightText,
  visible,
  autoHideDuration = DEFAULT_DURATION,
  onClose,
}) => {
  const safeType = TOAST_TYPES.includes(type) ? type : "info";

  useEffect(() => {
    if (!visible || autoHideDuration === null) return;
    const timer = setTimeout(() => onClose?.(), autoHideDuration);
    return () => clearTimeout(timer);
  }, [visible, autoHideDuration, onClose]);

  if (!visible) return null;

  const toastClassName = `${styles.toast} ${styles[`toast--${safeType}`]}`;

  return (
    <div
      className={toastClassName}
      role="alert"
      aria-live="assertive"
      data-testid="custom-toast"
      onClick={onClose}
    >
      {Icon && (
        <span className={styles.toast__icon}>
          <Icon />
        </span>
      )}
      <div className={styles.toast__text}>
        <span className={styles.toast__primary}>{primaryMessage}</span>
        {secondaryMessage && <span className={styles.toast__secondary}>{secondaryMessage}</span>}
      </div>
      <div
        className={classNames(styles.toast__right_text, styles.toast__primary)}
        dangerouslySetInnerHTML={{ __html: rightText }}
      ></div>
      <button
        className={styles.toast__close}
        title="Close"
        aria-label="Dismiss"
        tabIndex={0}
        onClick={(e) => {
          e.stopPropagation();
          onClose?.();
        }}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") onClose?.();
        }}
      >
        <i className="tg-icons-Cross"></i>
      </button>
    </div>
  );
};

Toast.propTypes = {
  icon: PropTypes.elementType,
  type: PropTypes.oneOf(TOAST_TYPES),
  primaryMessage: PropTypes.string.isRequired,
  secondaryMessage: PropTypes.string,
  rightText: PropTypes.string,
  visible: PropTypes.bool.isRequired,
  autoHideDuration: PropTypes.oneOfType([PropTypes.number, PropTypes.oneOf([null])]),
  onClose: PropTypes.func,
  // iconBgColor: PropTypes.string, // removed
};

export default Toast;
